import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";





import { PrimaryRole } from "../../../../auth/types/models/Role";

import RoleFormSelect from "../../../../auth/components/role/RoleForm/RoleFormSelect";









import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";









export const initialFormStateFn = () => { return {
    
        
        roleId: null,
        
    
        
        permission: "",
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.roleId = PrimaryRole.fromQuery(location.state?.roleId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        roleId:
        string()
                .nanoid(msg`Role is required`)
                .min(1, msg`Role is required`),
    
    
        permission:
        string()
        .trim()
        .min(1, msg`Permission is required`),
    
};

export const formSchema = object(formObject);

const RolePermissionAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <RoleFormSelect
        type="select"
        name="roleId"
        label={t`Role`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'permission' }
       aria-label="permission"
       data-testid="permission"
       label={t`Permission`}
       
       type='text'
       
   />
   
   
           
        </Container>
    )
}

export default RolePermissionAddForm;
